const modifyQueryParams = (queryParamsModifications) => {
  const params = new URLSearchParams(window.location.search)

  queryParamsModifications.forEach(({ action, data }) => {
    switch (action) {
      case "delete":
        data.forEach((param) => {
          if (params.has(param)) {
            params.delete(param)
          }
        })
        break
      case "set":
        Object.keys(data).forEach((param) => {
          params.set(param, data[param])
        })
        break
      default:
        console.log(`No such action for params: ${action}`)
    }
  })
  return params
}

const replaceHistoryState = (queryParamsModifications) => {
  const params = modifyQueryParams(queryParamsModifications)
  const queryParamsString = params.toString()
  //decode the url component to show '%2B' as '+' in the url bar as they are encoded by default by the `.toString()` method
  const url = decodeURIComponent(`${location.pathname}${queryParamsString ? "?" : ""}${queryParamsString}`)
  window.history.replaceState(window.history.state, document.title, url)
}

const pushHistoryState = (queryParamsModifications) => {
  const params = modifyQueryParams(queryParamsModifications)
  const queryParamsString = params.toString()
  //decode the url component to show '%2B' as '+' in the url bar as they are encoded by default by the `.toString()` method
  const url = decodeURIComponent(`${location.pathname}${queryParamsString ? "?" : ""}${queryParamsString}`)
  window.history.pushState(window.history.state, document.title, url)
}

export { pushHistoryState, replaceHistoryState, modifyQueryParams }
